import { Page } from "@ui/common/page/Page"
import React from "react"
import { ServiceRequestCreationModal } from "./ServiceRequestCreationModal"
import { WorkRequestsFilterButton, WorkRequestsFilterOverlay } from "./WorkRequestsFilterOverlay"
import { WorkRequestsQuickFilters } from "./WorkRequestsQuickFilters"
import { WorkRequestsTable } from "./WorkRequestsTable"
import { CreateNewWorkOrderModal } from "@ui/workOrders/CreateNewWorkOrderModal"
import { DI } from "@ui/DI"
import { useBlocCoordinator } from "@lib/bloc/hooks"

export function WorkRequestsScreen(): JSX.Element {
    const [state, viewModel] = useBlocCoordinator(() => DI.workRequestsFilterOverlayViewModel())

    const handleWorkOrderUpdated = () => {
        viewModel.applyFilters()
    }

    return (
        <Page className="page--work-requests" filterButton={WorkRequestsFilterButton}>
            <WorkRequestsFilterOverlay />
            <WorkRequestsQuickFilters />
            <WorkRequestsTable />
            <ServiceRequestCreationModal />
            <CreateNewWorkOrderModal onWorkOrderDeleted={handleWorkOrderUpdated} onClose={(wasModified) => {
                if (wasModified) {
                    handleWorkOrderUpdated()
                }
            }} onWorkOrderCreated={handleWorkOrderUpdated} />
        </Page>
    )
}
